{
  "list": {
    "title": "Research Reports"
  },
  "grid": {
    "headers": {
      "actions": "Actions",
      "created_by": "Created by"
    }
  },
  "reports": {
    "status": {
      "not_found": "No Report Found",
      "draft": "Draft",
      "in_review": "In Review",
      "verified": "Verified"
    },
    "actions": {
      "save_report": "Save Report",
      "edit_report": "Edit Report",
      "discard_changes": "Discard changes",
      "generate_section": "Generate section",
      "add_blank_section": "Add Blank Section",
      "share_report": "Share Report",
      "export_pdf": "Export PDF",
      "delete_report": "Delete Report",
      "menu": "Report actions",
      "delete": "Delete Prompt",
      "edit": "Edit Prompt"
    },
    "info": {
      "created_by": "Created by:",
      "created_on": "Created on:",
      "last_updated": "Last updated:"
    },
    "fields": {
      "report_title": "Report Title"
    },
    "confirmations": {
      "discard_all_title": "Discard all changes",
      "discard_all_content": "Are you sure you want to discard the changes to the report?",
      "exit_edit_mode": "Exit Edit Mode"
    },
    "share": {
      "link_label": "Link",
      "copy_link": "Copy link to clipboard"
    },
    "delete": {
      "title": "Delete Report?",
      "description": "You're about to permanently delete this Report from Nexl for everyone.",
      "cancel": "Cancel",
      "confirm": "Delete Report"
    }
  },
  "sections": {
    "all_sections": "All Sections",
    "create_section": "Create Section",
    "back_to_all_sections": "Back to All Sections",
    "status": {
      "draft": "Draft",
      "in_review": "In Review",
      "verified": "Verified",
      "generated_draft": "Generated Draft"
    },
    "names": {
      "report_section": "Report Section",
      "file_summary": "File Summary",
      "new_section": "New Section"
    },
    "actions": {
      "save_changes": "Save changes",
      "discard_changes": "Discard changes",
      "edit_section": "Edit section",
      "delete_section": "Delete section",
      "create_new_section": "Add New Section"
    },
    "file_summary": {
      "replace_file": "Replace File",
      "replace_file_warning": "Once you click on regenerate, the file will be replaced and you won't be able to revert the changes.",
      "regenerate": "Regenerate"
    },
    "fields": {
      "ai_prompt": "AI Prompt",
      "section_title": "Section Title",
      "sources": "Sources"
    },
    "confirmations": {
      "discard_title": "Discard section changes",
      "discard_content": "Are you sure you want to discard the changes to this section?",
      "save_title": "Save section changes",
      "save_content": "Are you sure you want to save the changes to this section?",
      "regenerate_title": "Overwrite this content?",
      "regenerate_content": "Regenerating this section will replace the existing content in the editor."
    },
    "types": {
      "add_blank_section": "Add Blank Section",
      "blank_section": "Blank Section",
      "blank_section_description": "Start with an empty rich text editor only",
      "file_summary": "File Summary",
      "file_summary_description": "Upload a file to summarise document using AI prompts",
      "ai_web_search": "AI Web Search",
      "ai_web_search_description": "Search across publicly available websites to find relevant content for your report.",
      "nexl_data": "Nexl Data",
      "nexl_data_description": "Select section type and generate content using Nexl data"
    }
  },
  "forms": {
    "labels": {
      "ai_prompt": "AI Prompt"
    },
    "buttons": {
      "generate": "Generate",
      "add": "Add"
    }
  },
  "data_sources": {
    "nexl_data": "Nexl Data",
    "contact_relationships": "Contact Relationships",
    "who_knows_who": "Who Knows Who",
    "practice_area_engagement": "Practice Area Engagement",
    "key_activities": "Key Activities",
    "opportunities": "Opportunities",
    "web_research": "Web Search",
    "file_summary": "File"
  },
  "search_types": {
    "headers": {
      "ai_web_search": "AI Web Search",
      "nexl_data": "Nexl Data",
      "file_summary": "File summary"
    },
    "captions": {
      "ai_web_search": "Search across publicly available websites to find relevant content for your report.",
      "nexl_data": "Select section type and generate content using Nexl data",
      "file_summary": "A new section will be added with AI-generated title and summary of the document."
    },
    "web_search": {
      "litigation_overview": "Litigation Overview",
      "description": "Description",
      "transaction_overview": "Transaction Overview",
      "legal_needs": "Legal Needs",
      "legal_department": "Legal Department",
      "financial_performance": "Financial Performance",
      "geographic_reach": "Geographic Reach",
      "strategy": "Strategy",
      "news": "News"
    },
    "nexl_search": {
      "relationships": "Relationships"
    }
  },
  "aria_labels": {
    "report_status_select": "Report Status",
    "section_status_select": "Section Status"
  },
  "confirmations": {
    "delete_report": {
      "title": "Delete Report",
      "title_with_name": "Delete report {{title}}",
      "message": "Are you sure you want to delete this report?"
    },
    "delete_section": {
      "title": "Delete Section",
      "message": "Are you sure you want to delete this section?"
    },
    "delete_prompt": {
      "title": "Are you sure you want to delete this prompt?",
      "message": "The prompt will be removed from the library, but any sections that have already utilised this report will remain unchanged."
    }
  },
  "status": {
    "success": {
      "title": "Successfully generated!"
    },
    "error": {
      "title": "An error occurred while generating the section.",
      "description": "Please try again later or contact support if the issue persists."
    },
    "loading": {
      "title": "Generating section content...",
      "description": "This may take a moment."
    },
    "alt": {
      "title": "Generating section content...",
      "description": "This may take a moment."
    }
  },
  "agent-state": {
    "connecting": "Connecting to AI agent...",
    "disconnecting": "Disconnecting from AI agent...",
    "disconnected": "Apologies, our AI seems to be offline. Please refresh the page and try again. If the issue persists, please contact your Administrator.",
    "error": "Apologies, there seems to be an error with our AI. Please refresh the page and try again. If the issue persists, please contact your Administrator."
  },
  "validation": {
    "report_title_required": "Report title is required",
    "section_title_required": "Section title is required"
  },
  "file_upload": {
    "header": "Create new report",
    "caption": "The selected prompt uses the File data source. Upload a file to summarise.",
    "validation": {
      "file_required": "File is required"
    }
  },
  "prompt_library": {
    "title": "Prompt Library",
    "info": {
      "data_source": "Data Source",
      "created_at": "Created At",
      "created_by": "Created By",
      "error": "Error",
      "no_prompts": "No prompts found",
      "all_tags": "All tags",
      "create_new_tag": "Type and enter to create new tags"
    },
    "actions": {
      "create_prompt": "Create Prompt",
      "save_prompt": "Save Prompt",
      "edit": "Edit Prompt",
      "delete": "Delete Prompt",
      "custom_prompt": "Custom Prompt"
    },
    "placeholders": {
      "prompt_search": "Search prompt",
      "select_data_sources": "Select Data Source",
      "select_tags": "Select Tags",
      "title": "Prompt Title",
      "prompt": "Prompt"
    },
    "labels": {
      "tag": "Tag",
      "data_source": "Data Source"
    },
    "aria_labels": {
      "prompt_search": "Search prompts by category or title"
    },
    "custom_prompt": {
      "ai_prompt": "AI Prompt",
      "ai_prompt_placeholder": "Enter Your Custom Prompt",
      "attachment": "Attachment"
    }
  }
}
